import { z } from 'zod';
import { macroRecordingInputPayloadSchema } from '../api/macroRecording';
import { macroInputDeviceSettingsSchema } from '../api/macroInputDevices';

/** Host physical input, timestamped on the take clock, before gesture coalescing. */
export const macroCapturedInputSchema = z.object({
  sequence: z.number().int().positive(), atMs: z.number().int().nonnegative(),
  phase: z.enum(['down', 'up', 'change']),
  payload: macroRecordingInputPayloadSchema,
});
export type MacroCapturedInput = z.infer<typeof macroCapturedInputSchema>;
export const macroInputCaptureRequestSchema = z.object({
  requestId: z.string().uuid(), takeId: z.string().uuid(),
  command: z.enum(['start', 'poll', 'stop']),
  afterSequence: z.number().int().nonnegative(),
  timelineOffsetMs: z.number().int().nonnegative(),
  devices: macroInputDeviceSettingsSchema,
  editorFocused: z.boolean(),
});
export type MacroInputCaptureRequest = z.infer<typeof macroInputCaptureRequestSchema>;
export const macroInputCaptureReplySchema = z.object({
  requestId: z.string().uuid(), takeId: z.string().uuid(), success: z.boolean(),
  events: z.array(macroCapturedInputSchema), elapsedMs: z.number().int().nonnegative(),
  stopped: z.boolean(), more: z.boolean(), error: z.string().optional(),
});
export type MacroInputCaptureReply = z.infer<typeof macroInputCaptureReplySchema>;
export type PlaycastMacroInputCaptureMessages =
  | { target: 'system'; action: 'macroRecorderInputCapture'; isReply: false; message: MacroInputCaptureRequest }
  | { target: 'system'; action: 'macroRecorderInputCapture'; isReply: true; message: MacroInputCaptureReply }
  | { target: 'record'; action: 'inputs'; isReply: false; message: MacroInputCaptureRequest & { localEditor: boolean } }
  | { target: 'record'; action: 'inputs'; isReply: true; message: MacroInputCaptureReply };
